module.exports = __webpack_public_path__ + "static/media/critter-mail-club.44c85c7c.png";